<template>
    <div class="article-excerpt">
        <dropdown v-if="showDropdown">
            <template #content>
                <ul>
                    <li>
                        <base-button to="/home">Condividi</base-button>
                    </li>

                    <li>
                        <base-button to="/home">Scrivi un commento</base-button>
                    </li>
                </ul>
            </template>
        </dropdown>

        <router-link :to="url" class="article-excerpt__link">
            <div class="article-excerpt__media">
                <div class="article-excerpt__image" :style="{'background-image': `url(${coverSrc})`}"></div>
            </div>

            <div class="article-excerpt__content">
                <div class="article-excerpt__entry">
                    <h3>{{title}}</h3>

                    <p>{{author}}</p>
                </div>

                <div class="article-excerpt__meta">
                    <div class="article-excerpt__rating">
                        <rating-stars
                            :rating="rating"
                        />
                    </div>

                    <p>{{readingsCount}} letture</p>
                </div>

                <div v-if="shared" class="article-excerpt__meta">
                    <div class="article-excerpt__entry">
                        <p><small>Condiviso da: {{ shared }}</small></p>
                    </div>
                </div>

            </div>
        </router-link>
    </div>
</template>

<script>
import Dropdown from '@/components/dropdown/dropdown';
import BaseButton from '@/components/base-button/base-button'
import RatingStars from '@/components/rating-stars/rating-stars'

export default {
    name: 'ArticleExcerpt',

    components: {
        Dropdown,
        BaseButton,
        RatingStars
    },

    props: {
        url: {
            type: String,
            default: '/'
        },

        coverSrc: {
            type: String,
            default: ''
        },

        title: {
            type: String,
            default: ''
        },

        author: {
            type: String,
            default: ''
        },

        rating: {
            type: [String, Number],
            default: ''
        },

        readingsCount: {
            type: [String, Number],
            default: ''
        },
        showDropdown: {
            type: Boolean,
            default: false
        },
        shared: {
            type: String,
            default: ''
        }
    },
}
</script>
